module.exports = __webpack_public_path__ + "static/media/Ramona Avenue, Albany, CA2.9af463d7.jpg";